import { Box, Flex } from '@chakra-ui/react';
import { scaleOrdinal } from '@visx/scale';
import { CT_QNT_COLORS, NO_AMPLIFICATION_COLOR } from '../chip-view-constant';
import { BaseLegend } from './base-legend';

interface Props {
  legendHeight: string;
  id?: string;
}

const LEGEND_LABELS = ['< 13', '< 16', '< 19', '< 22', '< 25', '< 28', '≥ 28', 'Not detected', 'No amplification'];
const LEGEND_COLORS = [...CT_QNT_COLORS, '#D1D5DB', '#FFFFFF', NO_AMPLIFICATION_COLOR];

export function CtLegend({ legendHeight, id }: Props) {
  const colorScale = scaleOrdinal<string, string>({ domain: LEGEND_LABELS, range: LEGEND_COLORS });

  return (
    <BaseLegend id={id} header="Ct" description="Cycle threshold">
      <Box
        display="flex"
        flexDirection="column"
        overflow="auto"
        marginLeft="-30px"
        paddingLeft="30px"
        height={legendHeight}
      >
        {LEGEND_LABELS.map(label => {
          const color = colorScale(label);
          return (
            <Flex key={label} alignItems="center" height="18px" paddingY="2px">
              <Box width="14px" height="14px" borderRadius="2px" marginRight="4px" backgroundColor={color} />
              <Box as="span" lineHeight="18px" whiteSpace="nowrap">
                {label}
              </Box>
            </Flex>
          );
        })}
      </Box>
    </BaseLegend>
  );
}
